const finalRoute = (route: string) => {
  if (route.endsWith("/")) {
    return route.slice(0, -1)
  }
  return route
}

export default finalRoute
